import { createAction, props } from "@ngrx/store";
import { ISkillNode } from "@skills-app/models/skillNode";

const prefix = "[Add Skill Alias]";

export const saveTemporarySkillAliases = createAction(
  `${prefix} Save Temporary Skill Aliases`,
);
export const selectParentSkill = createAction(
  `${prefix} Select Parent Skill`,
  props<{ parentSkill: ISkillNode }>(),
);
export const addTemporarySkillAlias = createAction(
  `${prefix} Add Temporary Skill Alias`,
  props<{ skill: ISkillNode }>(),
);
export const deleteTemporarySkillAlias = createAction(
  `${prefix} Delete Temporary Skill Alias`,
  props<{ skill: ISkillNode }>(),
);
